import { render, staticRenderFns } from "./ThreeStepProcessWrap.vue?vue&type=template&id=04ca010c&"
import script from "./ThreeStepProcessWrap.vue?vue&type=script&lang=js&"
export * from "./ThreeStepProcessWrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports